/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {IMember} from 'interfaces/channelProps';
import {IPortalError} from 'utility/error-handler';
import {
  CHANNEL_STREAMS_FETCHING,
  CHANNEL_STREAMS_FETCHING_DONE,
  CHANNEL_STREAMS_FETCHING_ERROR,
  ChannelsActions
} from 'store/action/channels';

export interface IChannelStreamsState {
  channelStreams: IMember[] | null;
  isFetching: boolean;
  error: null | IPortalError;
}

const initialChannelStreamsState: IChannelStreamsState = {
  channelStreams: null,
  isFetching: false,
  error: null
};
const channelStreamsReducer: Reducer<Readonly<IChannelStreamsState>, ChannelsActions> = (
  state: IChannelStreamsState = initialChannelStreamsState,
  action: ChannelsActions
) => {
  switch (action.type) {
    case CHANNEL_STREAMS_FETCHING:
      return {
        ...state,
        error: null
      };
    case CHANNEL_STREAMS_FETCHING_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    case CHANNEL_STREAMS_FETCHING_DONE:
      return {
        ...state,
        channelStreams: action.payload,
        error: null,
        isFetching: false
      };
    default:
      return state;
  }
};

export default channelStreamsReducer;